import { Component } from '@angular/core';

@Component({
  selector: 'app-pharmaceutical',
  templateUrl: './pharmaceutical.component.html',
  styleUrl: './pharmaceutical.component.scss'
})
export class PharmaceuticalComponent {

}
